import React, { useState, useEffect, useContext } from "react";
import axios from "../../../../axios/index";
import { Link, useHistory, useLocation } from "react-router-dom";

// context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import parse from "html-react-parser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// styles
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";
import styles from "./BlogDetailManagment.module.css";

import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg";

export default function BlogDetailManagment(props) {
  const { userToken } = useContext(UserContext);
  const { state } = useLocation();
  const history = useHistory();
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [blogData, setBlogData] = useState([]);
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  useEffect(() => {
    const getData = async () => {
      const getApiData = await axios.get(`Article/${state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      setIsLoading(false);
      setBlogData(getApiData.data.data);
    };
    getData();
  }, [userToken, state]);

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className={isShowSidebar ? "col-md-9" : "col-md-12"}>
              <div className={`mt-3 px-0 ${Dstyles.container}`} dir="rtl">
                <DashboardHeader setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} onClick={() => setModalShow(true)} />

                {/* head title */}
                <div className="py-2">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-start mt-4 px-4" dir="rtl">
                      <div className={`mt-3 mb-3 mb-md-0 ${styles.blog_title}`}>
                        <a href="#">
                          <img onClick={history.goBack} className="ms-2 pointer" src={arrowIcon} alt="icon" />
                        </a>
                        {blogData?.title}
                      </div>
                      <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center">
                        <div className="d-flex flex-column justify-content-center align-items-center mx-2 my-1">
                          <img
                            className={`mb-2 ${styles.profile_img}`}
                            loading="lazy"
                            src={`https://backdev.azrmelk.com/images/users/avatar/${blogData.userDto?.avatarName}`}
                            alt="profile"
                          />
                          <div className={styles.header_sub_title}>{blogData?.ownerName}</div>
                        </div>
                        <span className={styles.line}></span>
                        <div className="d-flex flex-column justify-content-center align-items-center mx-2 my-1">
                          <div className={`d-flex align-items-center justify-content-center mb-2 ${styles.bg_rounded}`}>
                            <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.3844 11.0985H10.5078" stroke="#323232" stroke-width="1.5" stroke-linecap="round" strokeLinejoin="round" />
                              <ellipse
                                cx="11.0109"
                                cy="10.5969"
                                rx="7.50313"
                                ry="7.50313"
                                stroke="#323232"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                strokeLinejoin="round"
                              />
                              <path d="M10.5106 11.0982V6.42773" stroke="#323232" stroke-width="1.5" stroke-linecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>

                          <div className={styles.header_sub_title}>
                            {blogData.dateRelease && blogData?.dateRelease?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
                          </div>
                        </div>
                        <span className={styles.line}></span>
                        <div className="d-flex flex-column justify-content-center align-items-center mx-2 my-1">
                          <div className={`d-flex align-items-center justify-content-center mb-2 ${styles.bg_rounded}`}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M2.59813 10.3885C2.46729 10.146 2.46729 9.85185 2.59813 9.60935C4.17479 6.69352 7.08729 4.16602 9.99979 4.16602C12.9123 4.16602 15.8248 6.69352 17.4015 9.61018C17.5323 9.85268 17.5323 10.1468 17.4015 10.3893C15.8248 13.3052 12.9123 15.8327 9.99979 15.8327C7.08729 15.8327 4.17479 13.3052 2.59813 10.3885Z"
                                stroke="#323232"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M11.7678 8.23223C12.7441 9.20854 12.7441 10.7915 11.7678 11.7678C10.7915 12.7441 9.20854 12.7441 8.23223 11.7678C7.25592 10.7915 7.25592 9.20854 8.23223 8.23223C9.20854 7.25592 10.7915 7.25592 11.7678 8.23223"
                                stroke="#323232"
                                stroke-width="1.4286"
                                stroke-linecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>

                          <div className={styles.header_sub_title}>{blogData.visit && blogData?.visit?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* head title */}

                {/* content */}
                <div className="container py-3 px-4 mb-4">
                  <div className="w-100 d-flex justify-content-center flex-wrap align-items-start mt-3" dir="rtl">
                    <div className="w-100 d-flex flex-column align-items-center justify-content-start flex-wrap">
                      <div className="w-100">
                        <img className={styles.blog_img} src={`https://backdev.azrmelk.com/magAssets/img/Articles/${blogData?.imageName}`} alt="blog-img" />
                      </div>
                      <div className="w-100 d-flex align-items-center justify-content-start p-3 mt-3">
                        <h4>{blogData?.title}</h4>
                      </div>
                      <div className="w-100 d-flex flex-column align-items-start justify-content-center px-5 text-wrap text-end">
                        {blogData?.aparatVideoUrl ? (
                          <div className="my-2 w-100">
                            {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                            <iframe
                              src={blogData.aparatVideoUrl}
                              className="w-100"
                              style={{
                                height: "550px",
                              }}
                              allowFullScreen="true"
                              webkitallowfullscreen="true"
                              mozallowfullscreen="true"></iframe>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="w-100 d-flex flex-column align-items-start justify-content-center px-5 text-wrap text-end">
                        {blogData?.body ? parse(`<body className=${styles.body_container}>${blogData?.body}</body>`) : parse("<p>متن بلاگ</p>")}
                      </div>
                    </div>
                  </div>
                </div>
                {/* content */}

                {/* buttons */}
                <div className="py-2">
                  <div className="container-fluid">
                    <div className="w-100 d-flex align-items-center justify-content-end px-4 mb-4">
                      <button className={`ms-3 border-danger ${styles.button_delete}`} onClick={deleteHandler}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash3 text-danger ms-2"
                          viewBox="0 0 16 16">
                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                        </svg>
                        حذف
                      </button>
                      <Link
                        to={{
                          pathname: `/edit-blog/${state.id}`,
                          state: blogData,
                        }}
                        className={`d-flex align-items-center justify-content-center ms-4 ${styles.button_submit}`}>
                        <svg className="ms-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M2.875 4.75001C2.57663 4.75001 2.29048 4.86854 2.0795 5.07952C1.86853 5.2905 1.75 5.57665 1.75 5.87501V17.125C1.75 17.4234 1.86853 17.7095 2.0795 17.9205C2.29048 18.1315 2.57663 18.25 2.875 18.25H14.125C14.2727 18.25 14.419 18.2209 14.5555 18.1644C14.692 18.1078 14.816 18.025 14.9205 17.9205C15.025 17.816 15.1078 17.692 15.1644 17.5555C15.2209 17.419 15.25 17.2728 15.25 17.125V8.50001C15.25 8.0858 15.5858 7.75001 16 7.75001C16.4142 7.75001 16.75 8.0858 16.75 8.50001V17.125C16.75 17.4697 16.6821 17.8111 16.5502 18.1296C16.4183 18.448 16.2249 18.7374 15.9812 18.9812C15.7374 19.2249 15.448 19.4183 15.1295 19.5502C14.8111 19.6821 14.4697 19.75 14.125 19.75H2.875C2.17881 19.75 1.51113 19.4735 1.01884 18.9812C0.526562 18.4889 0.25 17.8212 0.25 17.125V5.87501C0.25 5.17882 0.526562 4.51114 1.01884 4.01886C1.51113 3.52658 2.17881 3.25001 2.875 3.25001H10.7256C11.1398 3.25001 11.4756 3.5858 11.4756 4.00001C11.4756 4.41423 11.1398 4.75001 10.7256 4.75001H2.875Z"
                            fill="#21409A"
                          />
                          <path
                            d="M19.5597 0.496108C19.4912 0.420846 19.4081 0.360252 19.3156 0.31799C19.223 0.275727 19.1228 0.252672 19.0211 0.250219C18.9193 0.247765 18.8182 0.265964 18.7237 0.303715C18.6292 0.341466 18.5433 0.397985 18.4713 0.469857L17.8914 1.04689C17.8211 1.11721 17.7817 1.21255 17.7817 1.31197C17.7817 1.41138 17.8211 1.50673 17.8914 1.57704L18.423 2.10767C18.4578 2.14268 18.4992 2.17046 18.5448 2.18941C18.5905 2.20837 18.6394 2.21812 18.6887 2.21812C18.7381 2.21812 18.787 2.20837 18.8327 2.18941C18.8783 2.17046 18.9197 2.14268 18.9545 2.10767L19.5198 1.54517C19.8058 1.2597 19.8325 0.794701 19.5597 0.496108Z"
                            fill="#21409A"
                          />
                          <path
                            d="M16.7191 2.21876L8.25719 10.6656C8.20588 10.7167 8.16859 10.7802 8.14891 10.8499L7.7575 12.0156C7.74812 12.0473 7.74746 12.0808 7.75558 12.1128C7.7637 12.1448 7.78029 12.174 7.80362 12.1973C7.82695 12.2207 7.85615 12.2373 7.88813 12.2454C7.9201 12.2535 7.95368 12.2528 7.98531 12.2435L9.15016 11.852C9.21984 11.8324 9.28328 11.7951 9.33438 11.7438L17.7812 3.28095C17.8594 3.20197 17.9032 3.09534 17.9032 2.98423C17.9032 2.87312 17.8594 2.7665 17.7812 2.68751L17.3148 2.21876C17.2358 2.1399 17.1286 2.09562 17.017 2.09562C16.9053 2.09562 16.7981 2.1399 16.7191 2.21876Z"
                            fill="#21409A"
                          />
                        </svg>
                        ویرایش
                      </Link>
                    </div>
                  </div>
                </div>
                {/* buttons */}
              </div>
            </div>
            <div
              className={isShowSidebar ? "col-md-3" : "hidden"}
              style={{
                display: isShowSidebar ? "block" : "none",
              }}>
              {/* sideMenu starts */}
              <DashboardSideMenu blog blogs setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  async function deleteHandler() {
    setIsLoading(true);
    try {
      const apiData = await axios.delete(`Article?articleId=${state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(apiData)
      notify("مقاله با موفقیت حذف شد", "success");
      history.replace("/blog-dashboard");
    } catch (error) {
      notify("خطایی رخ داد", "error");
      history.replace("/blog-dashboard");
    }
    setIsLoading(false);
  }
}
